module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-toc-title"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Preface#uw6Nu8jevx7WBsCbljxQK8G"
    }
  }, [_vm._v("Preface")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Entries#uUBIMCtfVtDlyokIVdb2lO9"
    }
  }, [_vm._v("A")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Entries#u3DV39wJcyyxnRiVUpQiuu2"
    }
  }, [_vm._v("B")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Entries#udACbF6EzBRAADrjBy6v7eF"
    }
  }, [_vm._v("C")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Entries#upDezIo8lEvv6gfq3LtZfpG"
    }
  }, [_vm._v("D")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#uOmRokb2L3ic9thy9l7BrFF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#uJqoAohGM8KoodOMdOb6n6H",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#u3i8dBbl2JaSf5oZfpiUXOD",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#uYSueaksRS5uT4B4NcIZQwF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#u7BFVKo7DrtQTWTtTFijQFD",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#uFUAj8qndYWNxWYvGXs7tsF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0002#upFaPRCxHDYiBeGOTuhZNOD",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("K")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0002#uuZdy3XcIdSREOgyWSNJNDH",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("L")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0002#uAnW3tRSwiwTCa9AXFWL38C",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0002#u5dsrIz57DwlgcdBgGfBVLC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0002#uhJED7wuv6dpDhToMTcmR2B",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("O")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0002#u2FVmYKx3G8TB9dCSyxV78C",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0003#uDY5KoNHSHU9kZWsyhDXZz5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0003#uihcRYrcoAslJqfFL7kSaJ3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0003#uoXLYPeA7MDSp8uxzU8rxo7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0003#ug3F3ZDtfDCmwMynrjkBWZD",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("U")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0003#ulMgyjMGVTOZIaS3rtqppaG",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0003#uJgkKKrfqJQ8b9ChUwZiNm2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("W")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0003#unmngb5D52JIX5w28CkOzeF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Y")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0003#uV3Dpxf8IrgvP8Y6WrV8ol6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Z")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Afterword#u2UgyIT4D5u3RpTURMPiLB3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Index#urTaMVeZTD5FugEmiNbcLEF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Entry Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24614150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 69
// module chunks = 0